<template>
  <div class="notifications">
    <template v-for="c in content" :key="c.linkUrl">
      <Notification
        :notificationText="c.notificationText"
        :linkText="c.linkText"
        :linkUrl="c.linkUrl"
        :modalContent="c.modalContent"
        class="notification"
      ></Notification>
    </template>
  </div>
</template>

<script>
import Notification from './notification.vue';
export default {
  name: 'notifications',
  props: {
    content: {
      type: Array,
      required: true,
    },
  },
  components: {
    Notification,
  },
};
</script>
